export const QuestionType = {
    CHECKBOX: 'CheckBoxes',
    EMOJI_CHOICE: 'SmileyOptions',
    MULTI_CHOICE: 'MultipleChoices',
    PLAIN_TEXT: 'PlainText',
    RATING_SCALE: 'RatingScale',
    SECTION_TITLE: 'SectionTitle',
    YES_NO: 'YesOrNo',
    RANKING: 'RankingQuestion',
} as const;

export const questionTypeValues = Object.values(QuestionType);

export type QuestionTypeKey = keyof typeof QuestionType;
export type QuestionTypeValue = (typeof QuestionType)[QuestionTypeKey];
